import { render, staticRenderFns } from "./YMainBody.vue?vue&type=template&id=4ab278ed&scoped=true"
import script from "./YMainBody.vue?vue&type=script&lang=js"
export * from "./YMainBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab278ed",
  null
  
)

export default component.exports